import React from 'react';
import PropTypes from 'prop-types';
import RadioList from './RadioList';

import { WhatImDoingItems } from '../GrowthReports/reportDetails';
import utils from '../utils'; // importing default to allow mocking -> unit testing
import mutuallyExclusiveFiltersUtils from './mutuallyExclusiveFiltersUtils';

const propTypes = {
  containingTab: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  mutuallyExclusiveFilterState: PropTypes.shape().isRequired,
  onAccordionStateChange: PropTypes.func.isRequired,
  allReportDetails: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  sortingMethod: PropTypes.string.isRequired,
};

function WhatImDoingFilter({
  containingTab,
  identifier,
  value,
  mutuallyExclusiveFilterState,
  onAccordionStateChange,
  allReportDetails,
  sortingMethod,
}) {
  const radioListItems = mutuallyExclusiveFiltersUtils.disableFilterItems(
    WhatImDoingItems,
    mutuallyExclusiveFiltersUtils.getDisabledItemsFromMutuallyExclusiveFilter(mutuallyExclusiveFilterState)
  );

  /**
   * This function is passed to determine if the combination of a filter value an an mutuallyExclusive filter value result in 0 reports
   */
  const isFilterCombinationDisabled = (levelFilterValue, whatImDoingFilterValue) => {
    return (
      utils.filterGrowthReports(allReportDetails, levelFilterValue, whatImDoingFilterValue, sortingMethod).length === 0
    );
  };

  return (
    <RadioList
      containingTab={containingTab}
      identifier={identifier}
      items={radioListItems}
      onAccordionStateChange={onAccordionStateChange}
      value={value}
      onItemSelect={mutuallyExclusiveFiltersUtils.getItemValueAndMutuallyExclusiveFilterHandler(
        isFilterCombinationDisabled
      )}
    />
  );
}

WhatImDoingFilter.propTypes = propTypes;

export default WhatImDoingFilter;
